/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsGenericList1MelcoModelsThread,
    AssetsMelcoModelsGenericList1MelcoModelsThreadFromJSON,
    AssetsMelcoModelsGenericList1MelcoModelsThreadToJSON,
} from '../models';

export interface ThreadsApiAssetThreadsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    publishState?: string;
    searchText?: string;
    searchTextFields?: string;
    name?: string;
    code?: string;
    argb?: string;
    supplierId?: string;
    productId?: string;
}

/**
 * 
 */
export class ThreadsApi extends runtime.BaseAPI {

    /**
     */
    async assetThreadsSearchRaw(requestParameters: ThreadsApiAssetThreadsSearchRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsGenericList1MelcoModelsThread>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.searchTextFields !== undefined) {
            queryParameters['search_text_fields'] = requestParameters.searchTextFields;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.argb !== undefined) {
            queryParameters['argb'] = requestParameters.argb;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['product_id'] = requestParameters.productId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/threads`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsGenericList1MelcoModelsThreadFromJSON(jsonValue));
    }

    /**
     */
    async assetThreadsSearch(requestParameters: ThreadsApiAssetThreadsSearchRequest): Promise<AssetsMelcoModelsGenericList1MelcoModelsThread> {
        const response = await this.assetThreadsSearchRaw(requestParameters);
        return await response.value();
    }

}
